import React from 'react';
import AuthenticationInfo from '../common/AuthenticationInfo';
import { APGLEntityEntry } from '@amzn/awscat-editor/dist/extensions/apgl-entity';

/**
 * @deprecated Legacy global context. Do not use in new code.
 * For services, define a dedicated context in `/src/contexts/` and wire it
 * through `/src/components/AppProviders.tsx`. For app state, prefer hooks
 * or a dedicated service exposed via context.
 */
// @ts-expect-error TS2345 - strict migration
const AppContext = React.createContext<AppContextData>(undefined);

/**
 * @deprecated Legacy global context. Do not use in new code.
 * For services, define a dedicated context in `/src/contexts/` and wire it
 * through `/src/components/AppProviders.tsx`. For app state, prefer hooks
 * or a dedicated service exposed via context.
 */
function withAppContext(Component: any) {
  return function AppContextComponent(props: any) {
    return (
      <AppContext.Consumer>
        {(ctx) => <Component {...props} appContext={ctx} />}
      </AppContext.Consumer>
    );
  };
}

/**
 * @deprecated Legacy global context. Do not use in new code.
 * For services, define a dedicated context in `/src/contexts/` and wire it
 * through `/src/components/AppProviders.tsx`. For app state, prefer hooks
 * or a dedicated service exposed via context.
 */
interface AppContextData {
  isAuthenticated: boolean;
  authnInfo?: AuthenticationInfo;
  sideNavStatus: boolean;
  entities?: { [key: string]: APGLEntityEntry };
}

export { AppContext, withAppContext };
export type { AppContextData };
